<template>
  <div>
    <section class="banner">
      <v-layout column align-center justify-center class="banner-bottom">
        <div class="familiacantu white--text text-xs-center">Família Cantu</div>
        <div class="brasil white--text text-xs-center">NO BRASIL</div>
        <img src="/static/img/Ativo 10@4x.png" alt="FAMILIA CANTU" width="400" height="25">
      </v-layout>
    </section>

    <section class="banner3">
      <v-layout
        column
        wrap
        class="mt-5 ml-5 mr-5"
        align-center
      >
        <v-flex xs12 sm4 class="mt-3 ml-3 mr-3">
          <v-layout column align-center justify-center>
            <div class="historia text-xs-center">ENCONTRO ANUAL</div>
            <hr class="historiahr">
            <v-layout wrap align-center>
              <v-flex xs12 sm8 offset-sm2>
                
                <v-layout wrap align-center>
                  <v-flex xs12 sm6 >
                    <v-card-text class="text-xs-center text-historia">
                      Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh
                      euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad
                      minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit eum
                      iriure dolor in hendrerit in in vulputate velit esse molestie consequat, vel illum
                      dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio.
                    </v-card-text>
                  </v-flex> 
                  <v-flex xs12 sm6>
                
                    <img src="/static/img/Ativo 6@4x.png" alt="FAMILIA CANTU" height="10">
                  </v-flex>
                </v-layout>
              </v-flex>
             
            </v-layout>
           
            
          </v-layout>
        </v-flex>
      </v-layout>
    </section>
  </div>
</template>

<script>
import store from "../store";

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Hello ' + this.$store.state.world,
      server: this.$store.getters.server,
      model: {name: "", endereco: "", telefone: "", descricao: "", desconto: 0},
      descontos: [],
      message: "",
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
    }
  },
  created () {
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner {
    background-image: url('/static/img/Ativo 14@4x.png');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 850px;
    max-height: 100%;
    height: 260px;
    min-height: 260px;
    width: 100%;
    padding-top: 100px;
    position:relative; 
  }
  .brasil {
    font-size: 30px;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .historia {
    height: 60px;
    font-size: 50px;
    color: #a56d30;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .historiahr {
    width: 200px;
    border: 0; border-top: 1px solid #a56d30;
  }
  .familiacantu {
    height: 60px;
    widows: 220px;
    font-size: 60px;
    font-family: 'marguerite', sans-serif !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Encontro.vue